import { useState } from 'react';   

export default function FooterSettings() {
  const [email, setEmail] = useState('contact@sisi.com');
  const [phone, setPhone] = useState('+1 (555) 123-4567');
  const [address, setAddress] = useState('123 Fashion Street, New York, NY 10001');
  const [socialLinks, setSocialLinks] = useState([
    { platform: 'Facebook', icon: 'ri-facebook-fill', url: 'https://facebook.com' },
    { platform: 'Instagram', icon: 'ri-instagram-line', url: 'https://instagram.com' },
    { platform: 'Twitter', icon: 'ri-twitter-x-line', url: 'https://twitter.com' },
    { platform: 'Pinterest', icon: 'ri-pinterest-fill', url: 'https://pinterest.com' }
  ]);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSocialLinkChange = (index, field, value) => {
    const updated = [...socialLinks];
    updated[index] = { ...updated[index], [field]: value };
    setSocialLinks(updated);
  };

  const handleSave = () => {
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  const handleReset = () => {
    setEmail('contact@sisi.com');
    setPhone('+1 (555) 123-4567');
    setAddress('123 Fashion Street, New York, NY 10001');
    setSocialLinks([
      { platform: 'Facebook', icon: 'ri-facebook-fill', url: 'https://facebook.com' },
      { platform: 'Instagram', icon: 'ri-instagram-line', url: 'https://instagram.com' },
      { platform: 'Twitter', icon: 'ri-twitter-x-line', url: 'https://twitter.com' },
      { platform: 'Pinterest', icon: 'ri-pinterest-fill', url: 'https://pinterest.com' }
    ]);
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Footer Settings</h2>
        <p className="text-sm text-gray-600">Manage your footer contact information and social links</p>
      </div>

      {showSuccess && (
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center space-x-3">
          <i className="ri-checkbox-circle-fill text-green-600 text-xl"></i>
          <span className="text-sm text-green-800 font-medium">Footer settings saved successfully!</span>
        </div>
      )}

      <div className="space-y-6">
        {/* Contact Information */}
        <div className="p-6 bg-gray-50 rounded-lg border border-gray-200">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Contact Information</h3>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-lilac-400 focus:border-transparent text-sm"
                placeholder="contact@example.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Phone Number
              </label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-lilac-400 focus:border-transparent text-sm"
                placeholder="+1 (555) 123-4567"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Address
              </label>
              <textarea
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                rows={3}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-lilac-400 focus:border-transparent text-sm resize-none"
                placeholder="Enter your business address"
              />
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="p-6 bg-gray-50 rounded-lg border border-gray-200">
          <h3 className="text-sm font-semibold text-gray-900 mb-4">Social Media Links</h3>
          
          <div className="space-y-4">
            {socialLinks.map((link, index) => (
              <div key={index} className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-lilac-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${link.icon} text-white text-lg`}></i>
                </div>
                <div className="flex-1">
                  <input
                    type="url"
                    value={link.url}
                    onChange={(e) => handleSocialLinkChange(index, 'url', e.target.value)}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-lilac-400 focus:border-transparent text-sm"
                    placeholder={`${link.platform} URL`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Preview */}
        <div className="p-6 bg-gray-900 rounded-lg">
          <p className="text-sm font-medium text-white mb-4">Preview:</p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
            {/* Contact Info */}
            <div>
              <h4 className="text-white font-semibold mb-3 text-sm">Contact Us</h4>
              <div className="space-y-2">
                <div className="flex items-start space-x-2">
                  <i className="ri-mail-line text-lilac-400 text-sm mt-0.5"></i>
                  <span className="text-gray-300 text-xs">{email}</span>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-phone-line text-lilac-400 text-sm mt-0.5"></i>
                  <span className="text-gray-300 text-xs">{phone}</span>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-map-pin-line text-lilac-400 text-sm mt-0.5"></i>
                  <span className="text-gray-300 text-xs">{address}</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-3 text-sm">Quick Links</h4>
              <div className="space-y-2">
                <a href="#" className="block text-gray-300 hover:text-lilac-400 transition-colors text-xs">About Us</a>
                <a href="#" className="block text-gray-300 hover:text-lilac-400 transition-colors text-xs">Shop</a>
                <a href="#" className="block text-gray-300 hover:text-lilac-400 transition-colors text-xs">Contact</a>
              </div>
            </div>

            {/* Social Links */}
            <div>
              <h4 className="text-white font-semibold mb-3 text-sm">Follow Us</h4>
              <div className="flex space-x-3">
                {socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-lilac-400 transition-colors cursor-pointer"
                  >
                    <i className={`${link.icon} text-white text-base`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="pt-6 border-t border-gray-800 text-center">
            <p className="text-gray-400 text-xs">© 2024 SISI. All rights reserved.</p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-end space-x-3 pt-4 border-t border-gray-200">
          <button
            onClick={handleReset}
            className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium text-sm hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Reset to Default
          </button>
          <button
            onClick={handleSave}
            className="px-6 py-2.5 bg-lilac-400 text-white rounded-lg font-medium text-sm hover:bg-[#D94A85] transition-colors whitespace-nowrap cursor-pointer"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
